module.exports = __webpack_public_path__ + "static/media/icon-character__adolf-hitler-hover.639b3b1d.svg";